import { toZonedTime } from 'date-fns-tz';
import { Intervals } from '../../../../../utils/intervals';
import { Catalog } from '../../../catalog.types';

export enum CatalogStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  NOT_IN_VALIDITY_DATE = 'NOT_IN_VALIDITY_DATE',
}

const catalogInValidityDate = (catalog: Catalog): boolean => {
  const normalizedStartDate = catalog.startDate ? toZonedTime(catalog.startDate, 'UTC') : null;
  const normalizedEndDate = catalog.endDate ? toZonedTime(catalog.endDate, 'UTC') : null;

  if (normalizedStartDate && normalizedEndDate) {
    return Intervals.isNowWithinInterval(normalizedStartDate, normalizedEndDate);
  }

  if (normalizedStartDate && !normalizedEndDate) {
    return Intervals.isNowAfter(normalizedStartDate);
  }

  if (!normalizedStartDate && normalizedEndDate) {
    return Intervals.isNowBefore(normalizedEndDate);
  }

  return true;
};

export const getCatalogStatus = (catalog: Catalog): CatalogStatus => {
  if (!catalog?.active) {
    return CatalogStatus.INACTIVE;
  }

  if (catalogInValidityDate(catalog)) {
    return CatalogStatus.ACTIVE;
  }

  return CatalogStatus.NOT_IN_VALIDITY_DATE;
};
